import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../base/environment/utils';
import { IconScreenshare } from '../../base/icons/svg';
import Button from '../../base/ui/components/web/Button';
import { useSendToSecondScreen } from '../hooks.web';
const useStyles = makeStyles()(() => {
    return {
        button: {
            padding: '3px !important',
            borderRadius: '4px',
            '& svg': {
                width: '18px',
                height: '18px'
            }
        }
    };
});
/**
 * The tile counterpart of {@link SendToSecondScreenButton}, for the thumbnails
 * that have no context menu to add an entry to (a screenshare, the shared
 * video). It sits where the menu trigger sits on the other thumbnails and, like
 * it, appears on hover.
 *
 * @param {IProps} props - The component props.
 * @returns {ReactElement | null}
 */
const SendToSecondScreenIcon = ({ className, source, visible }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const { active, onClick, visible: enabled } = useSendToSecondScreen(source);
    // The thumbnails this sits on are themselves clickable (they pin), so the
    // click must not reach them.
    const _onClick = useCallback((e) => {
        e?.stopPropagation();
        onClick();
    }, [onClick]);
    const _onKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
        }
    }, []);
    // Stays put while its source is on a second screen, even once the pointer
    // leaves: it is the only way to take it off again, and a control that
    // vanishes on unhover would leave the tile with no sign that it is being
    // shown elsewhere.
    if (!enabled || (!visible && !active) || isMobileBrowser()) {
        return null;
    }
    return (React.createElement("span", { className: className, onKeyDown: _onKeyDown },
        React.createElement(Button, { accessibilityLabel: t(active ? 'multiScreen.removeFromSecondScreen' : 'multiScreen.sendToSecondScreen'), className: classes.button, icon: IconScreenshare, onClick: _onClick, size: 'small' })));
};
export default SendToSecondScreenIcon;
